import React, {useState} from 'react';
import {TextField, Typography, Button, Box, CircularProgress} from '@mui/material';
import {postData} from "../utils/api";


export default function AIDeskResearch() {
    /* eslint-disable */
    const [url, setUrl] = useState('');
    const [prompt, setPrompt] = useState('');
    const [submitClicked, setSubmitClicked] = useState(false);
    // const [email, setEmail] = useState('');
    // const [subject, setSubject] = useState('');
    // const [message, setMessage] = useState('');


    // State to hold the API response
    const [apiResponse, setApiResponse] = useState(null);
    const handleSubmit = async () => {
        setSubmitClicked(true);
        try {
            // Call your backend API endpoint
            postData(
                `${process.env.REACT_APP_BACKEND_URL}/api/v0/tutorial/url-question`, // Replace with your actual endpoint
                {url: url, prompt: prompt, email: "", subject: "", message: ""}
            ).then((data) => {
                if (data.status === 200) {
                    console.log(data)
                    // Suppose the server returns { answer: "some content" }
                    setApiResponse(data.data);
                    setSubmitClicked(false)
                } else {
                    throw new Error(data);
                }
            });

        } catch (error) {
            console.error('Error fetching data:', error);
            setApiResponse('An error occurred. Please try again.');
        }
    };


    // Conditionally render the form or the response box
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '500px',
                margin: '0 auto',
                gap: 2,
            }}
        >
            {apiResponse ? (
                // If we have a response, show it in a Box
                <Box>
                    <Typography variant="h6">API Response:</Typography>
                    <Typography variant="body1" sx={{whiteSpace: 'pre-wrap'}}>
                        {apiResponse}
                    </Typography>
                    <Button variant="contained" onClick={() => setApiResponse(null)}>
                        Go Back
                    </Button>
                </Box>
            ) : (
                // Otherwise, show the form
                <>

                    <Typography variant="h6">URLs to interact with</Typography>
                    <TextField
                        label="URL"
                        variant="outlined"
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                    />
                    <TextField
                        label="Prompt"
                        variant="outlined"
                        multiline
                        rows={4}
                        value={prompt ? prompt : "Über was informiert dieses Website?"}
                        onChange={(e) => setPrompt(e.target.value)}
                    />

                    {/*<Typography variant="h6">Mail Options</Typography>*/}
                    {/*<TextField*/}
                    {/*    label="E-Mail Address"*/}
                    {/*    variant="outlined"*/}
                    {/*    value={email}*/}
                    {/*    onChange={(e) => setEmail(e.target.value)}*/}
                    {/*/>*/}
                    {/*<TextField*/}
                    {/*    label="E-Mail Subject"*/}
                    {/*    variant="outlined"*/}
                    {/*    value={subject}*/}
                    {/*    onChange={(e) => setSubject(e.target.value)}*/}
                    {/*/>*/}
                    {/*<TextField*/}
                    {/*    label="Message"*/}
                    {/*    variant="outlined"*/}
                    {/*    multiline*/}
                    {/*    rows={4}*/}
                    {/*    value={message}*/}
                    {/*    onChange={(e) => setMessage(e.target.value)}*/}
                    {/*/>*/}
                    {submitClicked ? <CircularProgress/>
                        : <Button variant="contained" onClick={handleSubmit}>
                            Submit
                        </Button>}

                </>
            )}


        </Box>
    );
}
